module.exports = __webpack_public_path__ + "img/almoosa-admin.689aec95.jpg";